module.exports = __webpack_public_path__ + "img/47.22e4adb0.png";